import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // @ts-expect-error importing from JS file

import { fetchAdsUserAttributes } from 'AdsUI/actions/UserAttributesActions';
import FacebookCapiModal from 'AdsUI/components/announcements/FacebookCapiModal';
import useFacebookEvents from 'AdsUI/lib/useFacebookEvents';
import { getFacebookCapiLCSEvents, getHubSpotUserId // @ts-expect-error importing from JS file
} from 'AdsUI/selectors/AuthSelectors'; // @ts-expect-error importing from JS file

import { getRequestStatus } from 'AdsUI/selectors/RequestStatusSelectors'; // @ts-expect-error importing from JS file

import { getSeenFacebookCapiLcsModal } from 'AdsUI/selectors/UserAttributesSelectors';

const FacebookCapiModalContainer = () => {
  const {
    facebookCapiEvents,
    nonCapiFacebookLCSEvents
  } = useFacebookEvents();
  const dispatch = useDispatch();
  const hasFacebookCapiLcsEvents = useSelector(getFacebookCapiLCSEvents);
  const hasSeenFacebookCapiLcsModal = useSelector(getSeenFacebookCapiLcsModal);
  const userId = useSelector(getHubSpotUserId);
  const userAttributesRequestStatus = useSelector(getRequestStatus('userAttributes'));
  /** Evaluate if the "no action needed" modal should be open */

  const shouldOpenNoActionNeededModal = useCallback(() => {
    return facebookCapiEvents.length > 0 && nonCapiFacebookLCSEvents.length === 0 && hasFacebookCapiLcsEvents && !hasSeenFacebookCapiLcsModal && userAttributesRequestStatus.fetched;
  }, [facebookCapiEvents.length, nonCapiFacebookLCSEvents.length, hasFacebookCapiLcsEvents, hasSeenFacebookCapiLcsModal, userAttributesRequestStatus.fetched]);
  /** Evaluate if the "action required" modal should be open */

  const shouldOpenActionRequiredModal = useCallback(() => {
    return nonCapiFacebookLCSEvents.length > 0 && hasFacebookCapiLcsEvents && !hasSeenFacebookCapiLcsModal && userAttributesRequestStatus.fetched;
  }, [nonCapiFacebookLCSEvents.length, hasFacebookCapiLcsEvents, hasSeenFacebookCapiLcsModal, userAttributesRequestStatus.fetched]);
  const [isModalOpen, setIsModalOpen] = useState(shouldOpenNoActionNeededModal() || shouldOpenActionRequiredModal());
  useEffect(() => {
    // Deduplicate user attributes fetching
    if (!userAttributesRequestStatus.fetching && !userAttributesRequestStatus.fetched) {
      dispatch(fetchAdsUserAttributes(userId));
    }
  }, [userAttributesRequestStatus.fetching, userAttributesRequestStatus.fetched, dispatch, userId]);
  useEffect(() => {
    // Possibly open the modal after events and user attributes have been fetched
    setIsModalOpen(shouldOpenNoActionNeededModal() || shouldOpenActionRequiredModal());
  }, [shouldOpenNoActionNeededModal, shouldOpenActionRequiredModal]);
  return isModalOpen ? /*#__PURE__*/_jsx(FacebookCapiModal, {
    actionRequired: shouldOpenActionRequiredModal(),
    close: () => setIsModalOpen(false)
  }) : null;
};

export default FacebookCapiModalContainer;